exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1JI1Hb49VyoDymG0UxuF0l{display:flex;flex-direction:row;justify-content:space-between}._8zZmKVjh7_yHXEeV-vzvc{flex:1;height:100px;line-height:100px;margin:0 40px 20px;font-size:20px}.PolRnPadT-FV3Mb3MwLLH{font-size:28px}._14NglEnNoTk3Glg4SvsH_4{line-height:24px}._3LgUgjDUuy7EMPo0otA0Re{line-height:24px;height:auto;flex:1}._25Z2PP3iAnLsT-pdVQXXoh span{cursor:pointer;padding:.3em .5em;border-radius:5px}._25Z2PP3iAnLsT-pdVQXXoh span i{margin-right:.5em}._25Z2PP3iAnLsT-pdVQXXoh span:hover{background-color:#2b2665}@media screen and (max-width:700px){._1JI1Hb49VyoDymG0UxuF0l{width:100%;display:block}.PolRnPadT-FV3Mb3MwLLH{margin-top:-1em}._25Z2PP3iAnLsT-pdVQXXoh{margin-top:-2em}._3LgUgjDUuy7EMPo0otA0Re{margin-top:5em}}", ""]);

// exports
exports.locals = {
	"outerBox": "_1JI1Hb49VyoDymG0UxuF0l",
	"box": "_8zZmKVjh7_yHXEeV-vzvc",
	"nameBox": "PolRnPadT-FV3Mb3MwLLH",
	"statsBox": "_14NglEnNoTk3Glg4SvsH_4",
	"friendsBox": "_3LgUgjDUuy7EMPo0otA0Re",
	"actionBox": "_25Z2PP3iAnLsT-pdVQXXoh"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Users/Profile.scss
 ** module id = 345
 ** module chunks = 0
 **/